import clsx from "clsx";
import React from "react";

export type ButtonVariant = "primary" | "outline" | "transparent";

export type ButtonProps = {
    type?: JSX.IntrinsicElements["button"]["type"];
    children: React.ReactNode;
    disabled?: boolean;
    onClick?: () => void;
    className?: string;
    variant?: ButtonVariant;
    loading?: boolean;
    value?: string;
    "aria-controls"?: string;
    "aria-expanded"?: boolean;
};

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
    (
        {
            type,
            disabled,
            children,
            onClick,
            className,
            variant = "primary",
            loading = false,
            value,
            ...props
        },
        ref
    ) => {
        const baseClassName =
            "h-9 flex items-center justify-center px-5 font-semibold text-sm rounded-3xl transition-colors focus:outline-none";
        const _disabled = disabled || loading;
        return (
            <button
                value={value}
                className={clsx(
                    baseClassName,
                    variant === "primary" &&
                        !_disabled &&
                        " bg-soft-green-80 hover:bg-soft-green-70 focus:ring-2 focus:ring-surface-dark",
                    variant === "primary" &&
                        _disabled &&
                        "bg-soft-green-80 focus:ring-2 focus:ring-surface-dark opacity-40",
                    variant === "outline" &&
                        !_disabled &&
                        "bg-transparent border border-surface-dark hover:bg-surface-light-1",
                    variant === "outline" &&
                        _disabled &&
                        "bg-transparent border border-surface-dark opacity-40",
                    variant === "transparent" && !_disabled && "bg-transparent",
                    variant === "transparent" &&
                        _disabled &&
                        "bg-transparent opacity-40",
                    className
                )}
                type={type}
                disabled={_disabled || loading}
                onClick={onClick}
                ref={ref}
                {...props}
            >
                {loading ? "Loading..." : children}
            </button>
        );
    }
);

export default Button;
